import { render, staticRenderFns } from "./logo-svg.vue?vue&type=template&id=5933a69c&"
import script from "./logo-svg.vue?vue&type=script&lang=js&"
export * from "./logo-svg.vue?vue&type=script&lang=js&"
import style0 from "./logo-svg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports